import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

const Content = ({
  className = 'py-3',
  icon,
  line1,
  line1ClassName = 'text-gray-600',
  line2ClassName = 'text-blue-dark',
  line2,
}) => {
  return (
    <Row className={classNames('px-0 text-center text-gray-500', className)}>
      <Col xs={12} className="px-0">
        {icon}
      </Col>

      {line1 && (
        <Col
          xs={12}
          className={classNames('px-0 font-weight-bold', line1ClassName, {
            'pt-2': line2,
          })}
        >
          {line1}
        </Col>
      )}

      {line2 && (
        <Col
          xs={12}
          className={classNames(
            'px-0 font-weight-bold text-truncate',
            line2ClassName,
          )}
          title={line2}
          style={{ lineHeight: '20px' }}
        >
          {line2}
        </Col>
      )}
    </Row>
  );
};

Content.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.node.isRequired,
  line1: PropTypes.string,
  line1ClassName: PropTypes.string,
  line2: PropTypes.string,
  line2ClassName: PropTypes.string,
};

export default Content;
